import { brand } from "../brand";

/**
 * Per-brand marketing site origins (CRA inlines these at build time).
 * Local: both typically http://localhost:3000
 * Production builds: set the matching brand URL in CI.
 */
const MARKETING_URL_ENV_BY_BRAND: Record<string, string | undefined> = {
  gpqbank: process.env.REACT_APP_MARKETING_URL_GPQBANK,
  // Legacy alias while local/CI env files are updated
  mastergp: process.env.REACT_APP_MARKETING_URL_GPQBANK || process.env.REACT_APP_MARKETING_URL_MASTERGP,
  ophthalmologyq: process.env.REACT_APP_MARKETING_URL_OPHTHALMOLOGYQ,
};

function resolveMarketingOrigin(): string {
  const fromEnv = MARKETING_URL_ENV_BY_BRAND[brand.id]?.trim();
  const origin = (fromEnv || brand.marketingUrl || "").replace(/\/$/, "");
  return origin;
}

export const MARKETING_ORIGIN = resolveMarketingOrigin();

export function marketingUrl(path: string) {
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  return `${MARKETING_ORIGIN}${path.startsWith("/") ? path : `/${path}`}`;
}
